import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import getDomainNumber from 'rebook/apps/utils/urls/getDomainNumber';


const AdaptiveImage = ({ src, srcSet, alt, media, className }) => {
  const originalSrc = src.url.replace(/^(https?:\/\/.+)?\/[cp]\/[\dx]+\//, '');
  const originalSrcSet = srcSet.url.replace(/^(https?:\/\/.+)?\/[cp]\/[\dx]+\//, '');

  const staticDomains = STATIC_DOMAINS;
  const domain = staticDomains[getDomainNumber(originalSrc, staticDomains)];
  const url = `https://${domain}/c/${src.width}x${src.height}/${originalSrc}`;
  const url2x = `https://${domain}/c/${src.width*2}x${src.height*2}/${originalSrc}`;
  const srcSetUrl = `https://${domain}/c/${srcSet.width}x${srcSet.height}/${originalSrcSet}`;
  const srcSetUrl2x = `https://${domain}/c/${srcSet.width*2}x${srcSet.height*2}/${originalSrcSet}`;

  return (
    <LazyLoad offset={200} height={src.height}>
      <picture className={className}>
        <source srcSet={`${srcSetUrl}, ${srcSetUrl2x} 2x`} media={`(${media})`} />
        <source srcSet={`${url}, ${url2x} 2x`} />
        <img srcSet={`${url}, ${url2x} 2x`} alt={alt} />
      </picture>
    </LazyLoad>
  );
};

AdaptiveImage.propTypes = {
  src: PropTypes.object.isRequired,
  srcSet: PropTypes.object.isRequired,
  media: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

AdaptiveImage.defaultProps = {
  alt: '',
};

export default AdaptiveImage;
